import React from "react";
import styles from "./styles.module.scss";
import { PrimitiveProps } from "@helpers/interfaces/primitive";
import { UmbracoImage } from "@components/Image/UmbracoImage/UmbracoImage";
import { ImageField } from "@helpers/interfaces/image";
import { Link } from "@components/Link/Link";
import { Text } from "@components/Text/Text";
import { Box } from "@components/Box/Box";
import { Heading } from "@components/Heading/Heading";
import { AspectRatio } from "@components/AspectRatio/AspectRatio";

export interface ContactBoxProps extends PrimitiveProps {
  Key?: string;
  Image?: ImageField;
  Title: string;
  FullName: string;
  Description?: string;
  Email?: string;
  Phone?: string;
  ShowInfo?: boolean;
  format: string;
}

const ContactBox: React.FC<ContactBoxProps> = ({
  Image,
  Title,
  FullName,
  Description,
  Email,
  Phone,
  ShowInfo,
  format,
}) => {  
  return (
    <Box className={styles.contactBox}>
      {Image && (
        <AspectRatio ratio={format}>
        <UmbracoImage
          image={Image}
          width={[375, 300, 300, 300]}
          height={format === "4:5" ? [470, 440, 440, 440] : [375, 300, 300, 300]}
          params={{ mode: "crop" }}
        />
        </AspectRatio>
      )}
      <Heading as="h3" className={styles.fullname}>
        {FullName}
      </Heading>
      <Text className={styles.title}>{Title}</Text>
      {Phone && (
        <Text className={styles.linkcontact}>
          Tlf: <Link href={`tel:${Phone}`}>{Phone}</Link>
        </Text>
      )}
      {Email && (
        <Text className={styles.linkcontact}>
          <Link href={`mailto:${Email}`}>{Email}</Link>
        </Text>
      )}
      {Description && ShowInfo && (
        <Text className={styles.description}>{Description}</Text>
      )}
    </Box>
  );
};

ContactBox.defaultProps = {};

export { ContactBox };
